goog.provide('el8.ptdata.pmpCheckNotifications');

goog.require('el8.model.base');
goog.require('el8.template.ptdata.pmpCheckNotifications');


/**
 * Notifications that someone has accessed a PMP record for a chart
 * modeled after vipAccessNotification
 */
el8.ptdata.pmpCheckNotifications = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addIntProperty('accessingUserId');
    _class.addStringProperty('accessingUserName', true);
    _class.addDateTime('accessDatetime', true);
    _class.addStringProperty('chartFeedText', true);
    _class.addStringProperty('exportText', true);

    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.pmpCheckNotifications.noteSummary(this.asSoyMap()).el8_unescape();
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    _class.prototype.asSoyMap = function() {
        return this.parent.asSoyMap.call(this);
    };
    return that;

})();
